// @ts-nocheck
import { getOnePageCheckoutProductListOverlay } from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlaySelector";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useOnePageCheckoutProductListOverlay = convertSelectorToHook(getOnePageCheckoutProductListOverlay);
